import React from 'react';
import styled from 'styled-components';
import { SvgIcon, SvgIconProps } from '@make-software/cspr-design';

export const StyledInfoSvgIcon = styled(SvgIcon)(({ theme }) => ({
  path: {
    fill: theme.styleguideColors.contentTertiary,
  },
}));

export const InfoSvgIcon = React.forwardRef((props: SvgIconProps, ref) => (
  <StyledInfoSvgIcon ref={ref} role="img" alt={'Information icon'} {...props} />
));
